export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20angle%20overhead%20shot%20of%20a%20modern%20minimalist%20product%20sourcing%20command%20center%20with%20dual%20monitors%20displaying%20colorful%20spreadsheet%20dashboards%20and%20product%20trend%20charts%2C%20surrounded%20by%20curated%20fashion%20samples%20shoes%20bags%20and%20accessories%20on%20a%20warm%20oak%20desk%2C%20bright%20natural%20window%20light%2C%20cream%20and%20soft%20sage%20green%20palette%2C%20editorial%20workspace%20photography%20with%20clean%20airy%20composition%20and%20gentle%20shadows&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
        alt="ItaobuySpreadsheet product sourcing workspace with curated fashion items"
        title="ItaobuySpreadsheet — China Sourcing Spreadsheet Tool"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20 max-w-7xl mx-auto">
          <div className="flex-1 w-full">
            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white/60 bg-foreground-300 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20european%20male%20entrepreneur%20portrait%20with%20warm%20confident%20smile%2C%20clean%20studio%20lighting%20on%20soft%20sage%20green%20background%2C%20approachable%20friendly%20expression%2C%20minimalist%20professional%20headshot&width=80&height=80&seq=avatar-1-v2&orientation=squarish"
                    alt="Trusted seller"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white/60 bg-foreground-300 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20asian%20female%20business%20owner%20portrait%20with%20genuine%20smile%2C%20clean%20studio%20lighting%20on%20warm%20terracotta%20background%2C%20modern%20approachable%20headshot%2C%20minimalist%20professional%20photography&width=80&height=80&seq=avatar-2-v2&orientation=squarish"
                    alt="Trusted seller"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white/60 bg-foreground-300 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Friendly%20african%20american%20entrepreneur%20headshot%20with%20natural%20smile%2C%20clean%20studio%20lighting%20on%20warm%20oatmeal%20background%2C%20approachable%20and%20trustworthy%20expression%2C%20modern%20minimalist%20professional%20portrait&width=80&height=80&seq=avatar-3-v2&orientation=squarish"
                    alt="Trusted seller"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-white/80 text-xs md:text-sm font-medium tracking-wide">
                Trusted by 10,000+ eCommerce Sellers
              </span>
            </div>

            <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-heading font-bold leading-tight tracking-wide">
              ItaobuySpreadsheet
              <br />
              <span className="font-light text-white/90 text-2xl md:text-4xl lg:text-5xl">
                China Sourcing Tool
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 mt-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-foreground-950 rounded-lg text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap"
              >
                itaobuy sheet
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/15 text-white border border-white/30 rounded-lg text-sm font-semibold hover:bg-white/25 transition-all whitespace-nowrap backdrop-blur-sm"
              >
                buy it now
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-md">
            <p className="text-white/85 text-base md:text-lg leading-relaxed">
              Discover trending products, verified sourcing lists, and profitable China buying opportunities
              using the most advanced <strong className="text-white">itaobuy spreadsheet</strong> system.
              Save 30–70% on sourcing costs with structured product data designed for modern dropshippers
              and eCommerce entrepreneurs.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#categories"
          className="flex flex-col items-center gap-2 text-white/60 hover:text-white transition-colors"
        >
          <span className="text-xs font-medium">Scroll to explore</span>
          <i className="ri-arrow-down-line animate-bounce w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}